<div [ngClass]="{ 'modal-container': !atendimento }">
  <suite-rfb-collapse [title]="titulo">
    <via-parametros-pesquisa-pagamento [parametrosPesquisa]="this.parametrosPesquisa"
                                       [atendimento]="this.atendimento">
    </via-parametros-pesquisa-pagamento>
    <!-- A tabela não pode ficar dentro de uma condicional, pois alguns elementos da tabela são obtidos via {ViewChild} -->
    <!-- Uma alternativa seria utilizar o {ViewChildren}, mas até o momento não foi considerado necessário -->
    <div class="table-responsive">
      <!-- TODO VIA-3571522: Implementar regra de impressão DAS/DARF -->
      <via-suite-rfb-table #tabelaPagamentos
                           key="tabela-pagamentos"
                           trackByProp="ni"
                           [title]="this.tituloTabela"
                           [rows]="this.resultadosPesquisa"
                           [columns]="this.columns"
                           [detailTemplate]="detailTemplate"
                           [builtinActions]="null">
        <ng-template #templateBotaoAcoes let-resultado="row">
          <suite-rfb-popover-button #botaoAcoes
                                    container="div.table-responsive"
                                    [template]="menuAcoes"
                                    [templateContext]="{resultado}">
          </suite-rfb-popover-button>

          <ng-template #menuAcoes let-resultado="resultado">
            <div class="btn-group-vertical" style="z-index: 1000;" role="group">
              <button type="button" class="btn btn-default"
                      (click)="detalharPagamento(resultado); botaoAcoes.hide();">
                Detalhar
              </button>
              <button type="button" class="btn btn-default"
                      (click)="emitirComprovante(resultado); botaoAcoes.hide();">
                Emitir Comprovante
              </button>
              <button type="button" class="btn btn-default"
                      (click)="iniciarRetificacaoSimplificada(resultado); botaoAcoes.hide();">
                Retificação Simplificada
              </button>
              <button type="button" class="btn btn-default"
                      (click)="iniciarRetificacaoCompleta(resultado); botaoAcoes.hide();">
                Retificação Completa
              </button>
              <button type="button" class="btn btn-default"
                      (click)="trocarAssinalamento(resultado); botaoAcoes.hide();">
                Trocar Assinalamento
              </button>
              <button type="button" class="btn btn-default"
                      [disabled]="resultado.sistemaInteresseCd !== alocacaoAutomaticaTipoSistemaPermitido"
                      (click)="impedirAlocacaoAutomatica(resultado); botaoAcoes.hide();">
                Impedir Alocação Automática
              </button>
              <button type="button" class="btn btn-default"
                      [disabled]="resultado.sistemaInteresseCd !== alocacaoAutomaticaTipoSistemaPermitido"
                      (click)="liberarAlocacaoAutomatica(resultado); botaoAcoes.hide();">
                Liberar Alocação Automática
              </button>
            </div>
          </ng-template>
        </ng-template>

        <ng-template #templateNi let-resultado="row">
          @if (resultado.tipoNiRdoc === this.TipoNIRDOC.NI_INVALIDO) {
          <span>{{ resultado.ni | formatCpfCnpjPipe:resultado.tipoNi | vazio }}</span>
          }
          @else {
          <ni-com-link [ni]="resultado.ni"
                       [tipoNI]="resultado.tipoNi">
          </ni-com-link>
          }
        </ng-template>

        <ng-template #templateReceita let-resultado="row">
          <via-codigo-receita [codigo]="resultado.receita01.codigo.toString().padStart(4, '0')"></via-codigo-receita>
        </ng-template>

        <ng-template #templateBancoAgencia let-resultado="row">
          @if (resultado.pgtoAgenAgtaCd == null || resultado.pgtoAgenCd == null) {
          <span>-</span>
          }
          @else {
          <span>{{ resultado.pgtoAgenAgtaCd.toString().padStart(3, "0") }}/{{ resultado.pgtoAgenCd.toString().padStart(4, "0") }}</span>
          }
        </ng-template>

        <ng-template #detailTemplate let-resultado="row">
          <div class="contorno">
            <suite-rfb-collapse title="Detalhes do Pagamento">
              @if (resultado.tipoDocumento?.codigo == this.TipoDocumentoEnum.DAS) {
              <das-detalhes [pagamento]="resultado"
                            [parametrosConsultaPagamento]="parametrosPesquisa"
                            [atendimento]="atendimento">
              </das-detalhes>
              }
              @else if (resultado.tipoDocumento?.codigo == this.TipoDocumentoEnum.DJE) {
              <dje-detalhes [pagamento]="resultado"
                            [parametrosConsultaPagamento]="parametrosPesquisa"
                            [atendimento]="atendimento">
              </dje-detalhes>
              }
              @else {
              <darf-detalhes [pagamento]="resultado"
                             [parametrosConsultaPagamento]="parametrosPesquisa"
                             [atendimento]="atendimento">
              </darf-detalhes>
              }
            </suite-rfb-collapse>

            <composicao-detalhes [pagamento]="resultado"></composicao-detalhes>
            <utilizacao-detalhes [pagamento]="resultado"></utilizacao-detalhes>

          </div>
        </ng-template>
      </via-suite-rfb-table>

      <div class="d-flex justify-content-center">
        @if (this.initError == null && this.isLoading) {
        <loading-animation></loading-animation>
        }
      </div>

      <suite-rfb-alert-messages-with-datetime [onlyFor]="this.scopeId"></suite-rfb-alert-messages-with-datetime>
    </div>
  </suite-rfb-collapse>
</div>